<template>
  <!-- eslint-disable vue/no-v-html -->
  <v-navigation-drawer
    id="help-menu"
    v-model="showHelp"
    temporary
    right
    hide-overlay
    disable-route-watcher
    disable-resize-watcher
    touchless
    fixed
    class="fill-height"
    style="flex-direction: column; display: flex;"
    :width="350"
  >
    <v-toolbar flat>
      <v-toolbar-title>Help</v-toolbar-title>
      <v-spacer />
      <v-btn
        icon
        @click="showContextualHelp(false)"
      >
        <v-icon>close</v-icon>
      </v-btn>
    </v-toolbar>

    <v-progress-linear
      v-show="loading"
      indeterminate
      height="3"
      class="ma-0"
    />

    <v-container
      class="help__container"
    >
      <div
        v-if="content"
        id="help-content"
        v-html="content"
      />

      <v-subheader v-else-if="loading">
        Loading...
      </v-subheader>

      <v-subheader v-else>
        No Help found for this page
      </v-subheader>
    </v-container>

    <div class="pa-2">
      <v-btn
        :disabled="!tour"
        block
        outlined
        color="accent"
        @click="startTour"
      >
        <v-icon left>
          {{ runningTour ? 'stop' : 'play_arrow' }}
        </v-icon>
        {{ runningTour ? 'Stop Tour' : 'Start Tour' }}
      </v-btn>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { documentToHtmlString } from '@contentful/rich-text-html-renderer'
import { BLOCKS } from '@contentful/rich-text-types'
import hopscotch from 'hopscotch'
import 'hopscotch/dist/css/hopscotch.css'
import { mapState, mapMutations, mapActions } from 'vuex'

import contentful from '@/plugins/contentful'
import { getTourById } from './HelpTours'

const RENDERER_OPTIONS = {
  renderNode: {
    [BLOCKS.QUOTE]: (node, next) =>
      `<div class="v-alert v-alert--outlined info--text">${next(node.content)}</div></div>`
  }
}

export default {
  data () {
    return {
      content: null,
      loading: false,
      runningTour: false,
      tour: null
    }
  },
  computed: {
    ...mapState('help', [ 'show' ]),
    ...mapState('user', [ 'engagement' ]),
    showHelp: {
      get () { return !!this.show },
      set (val) { this.showContextualHelp(val) }
    }
  },
  watch: {
    '$route' (to, from) {
      if (this.showHelp) {
        this.searchHelpPages()
      } else {
        this.content = null
      }
    },
    showHelp () {
      if (this.showHelp) {
        if (typeof this.show === 'boolean') {
          this.searchHelpPages()
        } else {
          this.searchHelpPages(...this.show.split(':'))
        }
      }
    }
  },
  mounted () {
    hopscotch.listen('end', this.onTourEnd)
    hopscotch.listen('close', this.onTourEnd)
  },
  methods: {
    ...mapMutations('help', [ 'showContextualHelp' ]),
    ...mapActions('user', [ 'setEngagement' ]),
    async searchHelpPages (pageName = this.$route.name, type = 'help') {
      this.loading = true

      contentful
        .getEntries({
          'fields.id': pageName,
          content_type: type,
          limit: 1
        })
        .then(async entries => {
          if (!entries.items.length) {
            this.content = null
            return
          }

          // page found, be sure to open the drawer in case
          // the search has been requested for engagement purpose
          this.showHelp = true
          // if (!this.engagement || !this.engagement[pageName]) {
          //   this.setEngagement({ what: pageName, value: true })
          // }

          this.content = await documentToHtmlString(entries.items[0].fields.content, RENDERER_OPTIONS)

          // this.$nextTick(() => {
          //   this.fillAbbreviations()
          // })
        })
        .catch(() => {
          this.content = null
        })
        .then(() => {
          this.loading = false
        })

      this.searchTour()
    },
    searchTour () {
      this.tour = getTourById(this.$route.name)
    },
    startTour () {
      if (!this.tour) { return }

      if (this.runningTour) {
        hopscotch.endTour()
      } else {
        hopscotch.startTour(this.tour)
        this.showHelp = false
        this.runningTour = true
      }
    },
    onTourEnd () {
      this.showHelp = true
      this.runningTour = false
    },
    fillAbbreviations () {
      document.querySelectorAll('#help-content abbr').forEach(abbr => {
        // if (term) {
        //   abbr.title = term.title + ' (Click for glossary)'
        //   abbr.onclick = () => this.searchHelpPages(term.term, 'glossary')
        // }
      })
    }
  }
}
</script>

<style lang="scss">
.help__container {
  overflow: auto;
  flex-grow: 1;
  text-align: justify;

  .v-alert {
    p {
      margin: 0
    }
  }
}
</style>
